import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { HttpMethod } from 'src/constants/constant';
import { HttpCustomOptions } from 'src/services/http-interceptor.service';
import { ServiceManagerService } from '../service-manager.service';

@Component({
  selector: 'app-authentication',
  templateUrl: './authentication.component.html',
  styleUrls: ['./authentication.component.scss']
})
export class AuthenticationComponent implements OnInit {

  otpList = ['', '', '', '', '', '']
  email: any = '';
  constructor(public serviceManager: ServiceManagerService, public router: Router) {
    serviceManager.navToValidRoute()
    var state = this.router.getCurrentNavigation()?.extras?.state
    if(!state?.['email']){
      router.navigate(['/login'])
    }
    this.email = state?.['email']
   }

  ngOnInit(): void {
  }

  checkDisable(){
    return this.otpList.some((a: any) => !a.trim())
  }

  onKeyUp(event : any, curIndex: any){
    console.log(this.otpList);
    
    if(event.key === 'Delete' || event.key === 'Backspace'){
      console.log(curIndex)
      this.otpList[curIndex].length == 1 ? this.otpList[curIndex] = '':
      document.getElementById("otp"+ (curIndex-1))?.focus()
    }
    else if(this.otpList[curIndex].length === 1){
      console.log(curIndex)
      document.getElementById("otp"+ (curIndex+1))?.focus()
    }
  }

  trackByFn(index: any, item: any) {
    return index;
  }

  authenticateUser(){
    var body = {
      "otp": this.otpList.join(''),
      "email":this.email
    }
    const customOptions : HttpCustomOptions = {
      showErrorMessage: true,
      showSuccessMessage: false,
      createLoaderAction: true
    }
    this.serviceManager.CallBackendServiceAPI('authenticate-user', body, HttpMethod.POST, customOptions, false).subscribe( (data: any)=>{
      if(data){
        var response = data["response"]
        if(response["idToken"]){
          localStorage.setItem("idToken", response["idToken"])
          this.serviceManager.getProfileEmail()
        }
        this.router.navigate(['/people'])
      }
    })
  }
}
